<template>
  <div name="hrms15e-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-5 clear-padding">{{ labels['HRAP31EC5']['90'] }}</div>
      </div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <div name="hrms15e-item" class="evaluation-item clearfix">
          <div class="col-xs-12 subject">
            {{ labels['HRAP31EC5']['100'] }} {{ dataGroup.kpino }} {{ dataGroup.kpiitem }}
          </div>
          <div class="col-xs-12 special">
            {{ labels['HRAP31EC5']['120'] }} {{ dataGroup.desc_status }} <a class="fa fa-info-circle" @click="infoDetail()"></a>
          </div>

          <div class="col-xs-12 clear-padding ">
            <div class="col-xs-12 clear-padding">
              <div class="weight-box clearfix">
                <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> {{ labels['HRAP31EC5']['130'] }} : {{ dataGroup.kpiwgt }}</div>
                <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> {{ labels['HRAP31EC5']['140'] }} : {{ dataGroup.qtyscor }}</div>
                <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-pie-chart"></i> {{ labels['HRAP31EC5']['150'] }} : {{ dataGroup.avgscor }}</div>
              </div>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms15e-group',
  data () {
    return {
      groupDisp: true
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    infoDetail: {
      type: Function
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    }
  }
}
</script>


// WEBPACK FOOTER //
// group3.vue?37052e59